<div class="bcg p-3">
    <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6 pt-1">
            <p class="nav_link_cat_upload ms-1 "><span class="clickable" (click)="gotoDashboard()">Dashboard</span> >>
                Services
                >> Contract Execution Edit</p>
        </div>
        <div class="col-lg-3 col-sm-3 col-md-3 "></div>
        <div class="col-lg-3 col-sm-3 col-md-3 overlay_1">
            <app-select-branch (OnBranchChangeData) = changeState($event)></app-select-branch>
        </div>
    </div>

    <div *ngIf="showUploadDocuments" class="card mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="card-title title_header_0">Contract Execution - Edit</h5>
                    <p class="card-text text_p ">Ensure your documents are signed and stamped with ease by following a
                        few simple steps.</p>
                </div>
                <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                    <p-button label="Article Code List"
                    (click)="getArticleCode(articleList)" styleClass="p-button-sm-outline mx-2"></p-button> 
                    <p-button label="Back" [routerLink]="['/doqfy/cat-edit/form']"  styleClass="p-button-sm mx-2"></p-button>

                </div>
            </div>
        </div>
    </div>
    <div class="card mt-3 card_style_bs_order_cat">
        <div class="card-body">
            <h5 class="card-title title_header_0">Complete Your Process in Just 2 Easy Steps</h5>

            <div class="stepper-row">
                <ul class="steps_style box_cat_upload list-unstyled mb-0">
                    <li [ngClass]="[active_product ? 'box-item_active' : '', showUploadDocuments ? 'boxOutline' : 'box-item']"
                        class="clickable"
                        (click)="showUploadDocuments ? goToCatExecutionScreen('uploadDocs') : null">
                        1. Upload documents
                    </li>

                    <li [ngClass]="[active_confirm ? 'box-item_active' : '', showConfirmation ? 'boxOutline' : 'box-item']"
                        class="clickable">
                        2. Order confirmation
                    </li>
                </ul>
                <div *ngIf="!showConfirmation" class="overlay d-flex align-items-center gap-3">
                    <div class="d-flex align-items-center gap-2">
                        <small class="form_field" style="white-space: nowrap;">Convert CSV file into comma-separated format</small>
                        <a data-bs-toggle="modal" data-bs-target="#uploadDocModal" class="btn-link clickable upload-btn">
                            <p-button label="Upload & Convert"
                                (click)="uploadDocRef.openUploadDocPopup(); uploadDocRef.showColumnInput = true"
                                styleClass="p-button-sm-outline upload_button_label mr-2 mb-2">
                                <i class="upload_icon_color bx bx-upload bx-sm"></i>
                            </p-button>
                        </a>
                    </div>
                    <p-splitButton label="Download Template" [model]="itemsCatEdit" styleClass="p-button-sm mr-2 mb-2"></p-splitButton>
                </div>
            </div>
        </div>
    </div>

    <!-- Created useable components  so that we can use in estamp , esign and cat-upload Services     -->

    <div *ngIf="showUploadDocuments">
        <app-upload-document [uploadDocumentsData]="uploadDocumentsData"
            (uploadDocsChange)="onUploadDocsChange($event)"></app-upload-document>
    </div>

    <div *ngIf="showConfirmation">
        <app-order-confirmation-details #orderDetails [orderConfirmationData]="orderConfirmationData"
            (orderConfirmationChange)="onOrderConfirmationChange($event)"></app-order-confirmation-details>
    </div>

</div>


<ng-template #articleList let-modal>
    <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModel()"
            aria-label="Close"></button>
    </div>
    <app-article-code-list></app-article-code-list>

</ng-template>